// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width: 575.98px){.lx-grid-search-form[data-v-7f91deec]{width:100%}}", ""]);
// Exports
module.exports = exports;
